import {
  Box,
  Card,
  CardContent,
  Divider,
  Tooltip,
  Typography,
} from '@mui/material';
import { config } from 'config/config';
import React from 'react';

interface AddonCardProps {
  title: string;
  description: string;
  price: number | undefined;
  isChecked: boolean | undefined;
  id: string;
  numberOfDays?: number;
  onCheck: () => void;
  PayNowDiscAmount?: string | number;
  isLabel: boolean;
}

export const PaymentOptionCard: React.FC<AddonCardProps> = ({
  title,
  description,
  price,
  isChecked,
  id,
  numberOfDays,
  onCheck,
  PayNowDiscAmount,
  isLabel,
}) => {
  const style = {
    boxShadow: '-3px -3px 28px 0px #0670B1AB inset',
    background: 'linear-gradient(180deg, #EFF9FF 0%, #F2FAFF 100%)',
    display: 'block',
    height: 'auto',
    minHeight: '160px',
    maxHeight: '160px',
  };

  const activeBorder = {
    border: '4px solid #fff',
  };

  const paymentDiscountInactive = {
    width: '100%',
    padding: '5px',
    fontSize: '14px',
    background: '#B5D8FF',
    border: '1px dotted #033C5F',
    color: '#033C5F',

    borderRadius: '5px',
    // color: "#fff",
    // background: "#03466D",
    textAlign: 'center',
    marginBottom: '10px',
  };

  const paymentDiscountActive = {
    width: '100%',
    padding: '5px',
    fontSize: '14px',
    border: '1px dotted #033C5F',
    borderRadius: '5px',
    color: '#fff',
    background: '#03466D',
    textAlign: 'center',
    marginBottom: '10px',
  };

  return (
    <Card
      style={
        isChecked
          ? {
              ...activeBorder,
              borderRadius: '10px',
              height: '100%',
              cursor: 'pointer',
            }
          : {
              border: 'unset',
              borderRadius: '10px',
              height: '100%',
              cursor: 'pointer',
            }
      }
      onClick={onCheck}
    >
      <CardContent
        style={{
          ...style,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box
          className="checkbox-container"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          flex="1 0 auto"
          sx={{
            height: 'auto',
            maxHeight: '24px',
            minHeight: '24px',
          }}
        >
          <Typography variant="h6">{title}</Typography>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={onCheck}
            id={id}
          />
          <label htmlFor={id}></label>
        </Box>
        <Tooltip
          title={description}
          placement="top"
          enterDelay={300}
          leaveDelay={200}
        >
          <Typography className="checkbox-description">
            {description}
          </Typography>
        </Tooltip>
        {isLabel && (
          <Typography
            sx={isChecked ? paymentDiscountActive : paymentDiscountInactive}
          >
            Pay Now & Save AED {PayNowDiscAmount}
          </Typography>
        )}
        <Box className="card-footer" style={{ marginTop: 'auto' }}>
          {!isLabel && (
            <Divider sx={{ backgroundColor: 'lightgray', height: '1px' }} />
          )}
          <Typography className="payment-text" key={id}>
            <span className="currency-tag">{config.CURRENCY}</span>
            <span className="price">{price?.toFixed(2)}</span>
            <span className="booking-duration">
              {numberOfDays > 1
                ? `for ${numberOfDays} days`
                : `for ${numberOfDays} day`}
            </span>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
